<template lang="html">
  <section>
    <div class="grid text">
      <div class="col-md-12">
        <div class="filtros" @click="mostrarFiltros = !mostrarFiltros">
          <p class="text--grisa text--small text--italic">Filtros y búsqueda</p>
          <div v-show="!mostrarFiltros" >
            <p>
              Filtros actuales:
              {{ filtros.desde | fecha }} - {{ filtros.hasta | fecha }}
              {{ filtros.texto ? ", Título: " + filtros.texto : "" }}
              <span v-if="filtros.menciones.directa || filtros.menciones.competencia ||
              filtros.menciones.contexto">
                , Mención:
                {{ filtros.menciones.directa ? "Directa": "" }}
                {{ filtros.menciones.competencia ? "Competencia": "" }}
                {{ filtros.menciones.contexto ? "Contexto": "" }}
              </span>
              <span v-if="filtros.medios.televisión || filtros.medios.radio ||
              filtros.medios.prensa">
                , Medio:
                {{ filtros.medios.televisión ? "TV": "" }}
                {{ filtros.medios.radio ? "Radio": "" }}
                {{ filtros.medios.prensa ? "Prensa": "" }}
                {{ filtros.medios.md ? "Med. Dig.": "" }}
                {{ filtros.medios.rs ? "Red. Soc.": "" }}
              </span>
              <i class="fa fa-fw fa-chevron-down"/>
            </p>
          </div>
          <div v-show="mostrarFiltros">
            <p>Ocultar <i class="fa fa-fw fa-chevron-up"/></p>
          </div>
        </div>
      </div>
    </div>
    <div v-show="mostrarFiltros">
      <div class="grid fondo--negro2 filtros__body">
        <div class="col-md-6">
          <form-group>
            <input class="form__input text--blanco" v-model="filtros.texto" >
            <label class="form__label text--grisa">Búsqueda</label>
          </form-group>
          <div class="grid">
            <div class="col-md-6 form__group">
              <label class="form__label text--grisa">Desde</label>
              <datepicker language="es" input-class="form__input text--blanco"
                          v-model="filtros.desde"/>
            </div>
            <div class="col-md-6 form__group">
              <label class="form__label text--grisa">Hasta</label>
              <datepicker language="es" input-class="form__input text--blanco"
                          v-model="filtros.hasta"/>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="grid">
            <div class="col-md-6 lista-checks">
              <label class="form__label text--blanco">Tipo de Mención</label>
              <div class="checkbox checkbox--rojo">
                <input type="checkbox" id="ckDirecta" v-model="filtros.menciones.directa">
                <label class="form__label text--blanco" for="ckDirecta">Directa</label>
              </div>
              <div class="checkbox checkbox--rojo">
                <input type="checkbox" id="ckCompetencia" v-model="filtros.menciones.competencia">
                <label class="form__label text--blanco" for="ckCompetencia">Competencia</label>
              </div>
              <div class="checkbox checkbox--rojo">
                <input type="checkbox" id="ckContexto" v-model="filtros.menciones.contexto">
                <label class="form__label text--blanco" for="ckContexto">Contexto</label>
              </div>
            </div>
            <div class="col-md-6 lista-checks">
              <label class="form__label text--blanco">Tipo de Medio</label>
              <div class="checkbox checkbox--rojo">
                <input type="checkbox" id="ckTelevision" v-model="filtros.medios.television">
                <label class="form__label text--blanco" for="ckTelevision">Televisión</label>
              </div>
              <div class="checkbox checkbox--rojo">
                <input type="checkbox" id="ckRadio" v-model="filtros.medios.radio">
                <label class="form__label text--blanco" for="ckRadio">Radio</label>
              </div>
              <div class="checkbox checkbox--rojo">
                <input type="checkbox" id="ckPrensa" v-model="filtros.medios.prensa">
                <label class="form__label text--blanco" for="ckPrensa">Prensa</label>
              </div>
              <div class="checkbox checkbox--rojo">
                <input type="checkbox" id="ckMedDig" v-model="filtros.medios.md">
                <label class="form__label text--blanco" for="ckMedDig">Medios Digitales</label>
              </div>
              <div class="checkbox checkbox--rojo">
                <input type="checkbox" id="ckRedSoc" v-model="filtros.medios.rs">
                <label class="form__label text--blanco" for="ckRedSoc">Redes Sociales</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="text--center">
            <button class="boton boton--rojo" @click="buscarNotas(filtros)">
              <i class="fal fa-fw fa-search" />
              <span>Buscar</span>
            </button>
            <button class="boton boton--gris" @click="limpiar">
              <i class="fal fa-fw fa-eraser" />
              <span>Limpiar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";

function data() {
  return {
    mostrarFiltros: false,
    filtros: {
      texto: null,
      desde: moment().subtract(7, "d").startOf("day").toDate(),
      hasta: moment().endOf("day").toDate(),
      menciones: {},
      medios: {},
    },
  };
}

function checkFechas(filtros) {
  if (filtros.desde && filtros.hasta) {
    if (moment(filtros.desde).diff(moment(filtros.hasta)) <= 0) {
      return {
        desde: moment(filtros.desde).startOf("day").format(),
        hasta: moment(filtros.hasta).endOf("day").format(),
      };
    }
    this.$toastr("error", "La fecha de inicio no puede ser mayor a la fecha de fin", "Error");
    return false;
  }
  this.$toastr("error", "Debe seleccionar un rango de fechas", "Error");
  return false;
}

function buscarNotas(filtros) {
  const fechas = this.checkFechas(filtros);
  if (fechas) {
    const clonFiltros = cloneDeep(filtros);
    clonFiltros.desde = fechas.desde;
    clonFiltros.hasta = fechas.hasta;
    this.filtrosGlobales = this.filtros;
    this.$eventBus.$emit("buscarNotas", this.filtros);
    this.mostrarFiltros = false;
  }
}

function limpiar() {
  this.filtros = {
    texto: null,
    desde: moment().subtract(7, "d").startOf("day").toDate(),
    hasta: moment().endOf("day").toDate(),
    menciones: {},
    medios: {},
  };
  this.filtrosGlobales = this.filtros;
  this.$eventBus.$emit("buscarNotas", this.filtros);
  this.mostrarFiltros = false;
}

function created() {
  this.filtrosGlobales = this.filtros;
}

export default {
  data,
  store: ["filtrosGlobales"],
  created,
  methods: {
    buscarNotas,
    checkFechas,
    limpiar,
  },
};
</script>

<style lang="scss">
@import "../../sass/base/colores";
@import "../../sass/tema/colores";
@import "../../sass/base/helpers";
@import "../../sass/tema/globales";

.filtros {
  color: $blanco;
  border-bottom: 1px solid #gris6;
  padding: 0 0 .5em 0;
  text-align: right;
  cursor: pointer;
}

.filtros__body {
  position: relative;
  z-index: 4;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/notas/FiltroNotas.vue